<template>

  <div>
    <el-button style="float: right" type="primary" icon="el-icon-plus" @click="save()" >添加</el-button>
    <div class="policyClass">
      <el-table :data="course" class="tb-edit" style="margin:0 auto">
        <el-table-column prop="te_id" label="id" style="width:25%">
        </el-table-column>
        <el-table-column prop="te_title" label="标题" style="width:25%">
        </el-table-column>
        <el-table-column prop="te_time" label="发布时间" style="width:25%">
          <template slot-scope="scope">
            {{scope.row.date | moment}}
          </template>
        </el-table-column>
        <el-table-column prop="te_state" label="状态" style="width:25%">
          <template slot-scope="scope">
            <p v-if="scope.row.te_state == 0" style="color:green;">启用</p>
            <p v-else style="color:red;">禁用</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="width:25%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.te_state"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1"
              @change="changeState($event,scope.row.te_id)"
              style="margin-right: 10px">
            </el-switch>
            <el-button size="small" style="color:blue" @click="changeCourse(scope.row.te_id,scope.row.te_title,scope.row.te_text,scope.row.te_state)" >编辑</el-button>
            <el-button size="small" style="color:red" @click="deleteCourse(scope.row.te_id)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    inject:['reload'],
    data(){
      return {
        rohs: true,

        course:[],
        te_state:null,
      }
    },
    mounted(){
      this.getRowCourse();
    },
    methods:{
      changeCourse(id,title,text,state){
          this.$router.push({
            path:'/updateCourse',
            query: {
              te_id:id,
              te_title:title,
              te_text:text,
              te_state:state,
            }
          })
      },
      deleteCourse(id){
        this.$inbound.post({
          interfaceId: 'course/deleteCourse',
          data:{
            te_id:id
          },
        }).then(response => {
          this.reload()
        }).catch(error => {
          console.log(error)
        })
      },
      changeState(data,id){
        this.$inbound.post({
          interfaceId: 'course/updateCourseState',
          data:{
            te_id:id
          },
        }).then(response => {
          this.reload()
        }).catch(error => {
          console.log(error)
        })
      },
      getRowCourse(){
        this.$inbound.post({
          interfaceId: 'course/selectRowCourse',
        }).then(response => {
          console.log(response)
          this.course=response
        }).catch(error => {
          console.log(error)
        })
      },
      save(){
        this.$router.replace({path:'/insertCourse'})
      }
    }
  }
</script>

<style scoped>
</style>
